import React from 'react';
import './index.css';
import './App.css';
import Navigation from './components/Navigation/NavigationBar';
import ScrollToTop from './components/Navigation/ScrollToTop';
import Home from './components/Home/Home';
import AboutMe from './components/AboutMe/AboutMe';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';

const App = () => {
  return (
    <div className="app-container">
      {/* Cinematic Background Elements */}
      <div className="orb-container">
        <div className="bg-orb bg-orb-1"></div>
        <div className="bg-orb bg-orb-2"></div>
        <div className="bg-orb bg-orb-3"></div>
      </div>

      {/* Global Navigation */}
      <Navigation />
      <ScrollToTop />

      {/* Main Content Wrapper */}
      <div className="content-wrapper">
        <section id="homeBlock" className="section-block">
          <Home />
        </section>

        <section id="aboutMeBlock" className="section-block">
          <AboutMe />
        </section>

        <section id="projectsBlock" className="section-block" style={{ flexDirection: 'column', minHeight: 'auto' }}>
          <Projects />
        </section>

        <section id="contactBlock" className="section-block">
          <Contact />
        </section>
      </div>
    </div>
  );
};

export default App;